import React from 'react';
import styles from './Button.styl';

class Button extends React.Component
{
	render() {
		const className = this.props.disabled ?
			(this.props.buttonDisabledStyle || styles.buttonDisabled)
			: (this.props.buttonStyle || styles.button);

		const onClick = !this.props.disabled ? this.props.onClick : null;

		let style = this.props.style ? this.props.style : {};

		if (this.props.x) {
			style.left = `${this.props.x}px`;
		}

		if (this.props.y) {
			style.top = `${this.props.y}px`;
		}

		return (
			<div className={className} onClick={onClick} style={style} title={this.props.title ? this.props.title : null}>
				{this.props.iconStyle &&
					<div className={this.props.iconStyle || styles.icon}></div>
				}
				<span className={this.props.textStyle || styles.text}>{this.props.text}</span>
			</div>
		);
	}
}

export default Button;



// WEBPACK FOOTER //
// ./src/react/ui/button/Button.jsx